<template>
  <form v-if="!loading" @submit.prevent="onSubmit()">
    <div class="row">
      <div class="col-3">
        <app-autocomplete
          label="Produto"
          field="name"
          :searchFunction="searchProductFn"
          :resourceIdFunction="resourceProductFn"
          v-model="point.product_id"
          :errors="errors.product_id"
          required
        ></app-autocomplete>
      </div>
      <div class="col-2">
        <app-input
          label="Pontos"
          v-model.lazy="point.points"
          v-money="{ decimal: ',', thousands: '.', precision: 2 }"
          :errors="errors.points"
        ></app-input>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-12">
        <button :disabled="$v.$invalid || saving" type="submit" v-app-button>
          Salvar
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import CampaignPointsService from '@/services/campaign-points.service';
import ProductsService from '@/services/product.service';
import ToastMixin from '@/mixins/ToastifyMixin';

import { required } from 'vuelidate/lib/validators';

export default {
  name: 'campaign-points-form',
  props: ['id', 'errors', 'saving'],
  mixins: [ToastMixin],
  data: () => {
    return {
      loading: true,
      point: {
        product_id: null,
        points: null,
      },
    };
  },
  validations: {
    point: {
      product_id: { required },
      points: { required },
    },
  },
  methods: {
    loadPoint(id) {
      CampaignPointsService.getId(id)
        .then(({ data: point }) => {
          this.point = {
            ...point,
            points: point.points.toFixed(2),
          };
        })
        .catch(() => this.toastify('Erro ao carregar Ponto.', 'error'))
        .finally(() => (this.loading = false));
    },
    onSubmit() {
      this.$emit('submit', {
        ...this.point,
        points: parseFloat(
          this.point.points.replace('.', '').replace(',', '.')
        ),
      });
    },
    searchProductFn: (term) =>
      ProductsService.search({ term, paginate: false }),
    resourceProductFn: ProductsService.getId,
  },
  beforeMount() {
    if (this.id) this.loadPoint(this.id);
    else this.loading = false;
  },
};
</script>

<style lang="scss" scoped>
.input-error {
  position: relative;
  top: -12px;
}
</style>
